import React from 'react';
import { FormInput, FormInputProps } from './FormInput';

// eslint-disable-next-line react/display-name
export const TextInput = React.forwardRef<HTMLInputElement, FormInputProps>(
  (props: FormInputProps, ref: any) => {
    return <FormInput {...props} type='text' ref={ref} />;
  }
);
